/* MCM standalone desktop navigation; no Horizon internals are modified. */
(() => {
  function init(nav) {
    if (nav.dataset.mcmReady) return;
    nav.dataset.mcmReady = 'true';
    const button = nav.querySelector('[data-mcm-toggle]');
    const panel = nav.querySelector('[data-mcm-panel]');
    if (!button || !panel) return;
    const categories = [...nav.querySelectorAll('[data-mcm-category]')];
    const groups = [...nav.querySelectorAll('[data-mcm-group]')];
    const discoverGroups = [...nav.querySelectorAll('[data-mcm-discover-group]')];
    const fallback = nav.querySelector('[data-mcm-discover-fallback]');
    const opening = nav.querySelector('[data-mcm-opening]');
    const secondary = nav.querySelector('.mcm-hnav__secondary');
    const discover = nav.querySelector('.mcm-hnav__discover');
    const returnButton = nav.querySelector('[data-mcm-spotlight-return]');
    const hasOpening = () => !!opening?.querySelector('[data-mcm-spotlight-slide]');
    const showOpening = (editorPreview = false) => {
      if (!opening || (!hasOpening() && !editorPreview)) {
        const active = categories.find(el => el.getAttribute('aria-expanded') === 'true') || categories[0];
        if (active && (!opening || opening.hidden)) select(active.dataset.index);
        return;
      }
      opening.hidden = false;
      if (secondary) secondary.hidden = true;
      if (discover) discover.hidden = true;
      categories.forEach(el => el.setAttribute('aria-expanded', 'false'));
      if (returnButton) returnButton.hidden = true;
    };
    returnButton?.addEventListener('click', () => {
      showOpening();
      opening.querySelector('[data-mcm-spotlight-slide]:not([hidden]) a, [data-mcm-spotlight-next]')?.focus();
    });
    const dropdowns = [...nav.querySelectorAll('[data-mcm-dropdown]')];
    const closeDropdowns = except => dropdowns.forEach(item => { if(item !== except) item.open = false; });
    dropdowns.forEach(item => item.addEventListener('toggle', () => {
      if(item.open) { close(); closeDropdowns(item); }
    }));
    const close = () => { panel.hidden = true; button.setAttribute('aria-expanded','false'); };
    const select = (index) => {
      if (opening) opening.hidden = true;
      if (secondary) secondary.hidden = false;
      if (discover) discover.hidden = false;
      if (returnButton) returnButton.hidden = !hasOpening();
      categories.forEach(el => {
        el.setAttribute('aria-expanded', String(el.dataset.index === index));
      });
      groups.forEach(el => { el.hidden = el.dataset.index !== index; });
      let hasContent = false;
      discoverGroups.forEach(el => {
        const matches = el.dataset.index === index;
        el.hidden = !matches;
        if (matches && [...el.querySelectorAll('[data-mcm-discover-editor-block]')].some(block => !block.hidden)) hasContent = true;
      });
      if (fallback) fallback.hidden = hasContent;
      nav.dispatchEvent(new CustomEvent('mcm:category-selected'));
    };
    if (categories.length) select(categories[0].dataset.index);
    const open = () => {
      closeDropdowns();
      document.querySelectorAll('[data-mcm-panel]').forEach(el => { el.hidden = true; });
      document.querySelectorAll('[data-mcm-toggle]').forEach(el => el.setAttribute('aria-expanded','false'));
      panel.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      nav.dispatchEvent(new CustomEvent('mcm:category-selected'));
    };
    button.addEventListener('click', () => {
      if (panel.hidden) {
        showOpening();
        open();
      }
      else close();
    });
    categories.forEach(el => {
      el.addEventListener('click', () => select(el.dataset.index));
    });
    const outside = event => { if (!nav.contains(event.target)) { close(); closeDropdowns(); } };
    document.addEventListener('pointerdown', outside);
    nav.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const dropdown = event.target.closest('[data-mcm-dropdown]') || dropdowns.find(item => item.open);
      if (dropdown?.open) { dropdown.open = false; dropdown.querySelector('summary')?.focus(); }
      else { close(); button.focus(); }
      event.preventDefault();
    });
    const updateDiscover = () => {
      const active = categories.find(el => el.getAttribute('aria-expanded') === 'true');
      if (active && (!opening || opening.hidden)) select(active.dataset.index);
    };
    nav.addEventListener('mcm:discover-updated', updateDiscover);
    const previewBlock = event => {
      if (!nav.contains(event.target)) return;
      if (opening?.contains(event.target)) { showOpening(true); open(); return; }
      const group = event.target.closest('[data-mcm-discover-group]');
      if (!group) return;
      if (categories.some(el => el.dataset.index === group.dataset.index)) select(group.dataset.index);
      else {
        discoverGroups.forEach(el => { el.hidden = true; });
        if (fallback) fallback.hidden = true;
      }
      // Also allow an unconfigured group to be edited and assigned a category.
      group.hidden = false;
      open();
    };
    document.addEventListener('shopify:block:select', previewBlock);
    const unload = event => {
      if (!event.target.contains(nav)) return;
      close();
      document.removeEventListener('shopify:block:select', previewBlock);
      document.removeEventListener('pointerdown', outside);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }
  function boot(root = document) { root.querySelectorAll('[data-mcm-hnav]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
